import { render, staticRenderFns } from "./NewWitness.vue?vue&type=template&id=2c7b704f&"
import script from "./NewWitness.vue?vue&type=script&lang=js&"
export * from "./NewWitness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports